(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('PaperPriceDeleteController',PaperPriceDeleteController);

    PaperPriceDeleteController.$inject = ['$uibModalInstance', 'entity', 'PaperPrice'];

    function PaperPriceDeleteController($uibModalInstance, entity, PaperPrice) {
        var vm = this;

        vm.paperPrice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PaperPrice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
